import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import StoreIcon from "@mui/icons-material/Store";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link, useNavigate } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import CategoryIcon from '@mui/icons-material/Category';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import { useContext, useState, useEffect, useRef } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from "react-i18next";
import newRequest from "../../utils/newRequest";
import { GrTemplate } from "react-icons/gr";
import InsertPageBreakIcon from "@mui/icons-material/InsertPageBreak";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GtrackLogo from "../../images/Fats New logo.png";

const Sidebar = () => {
  // import  dark 
  const { darkMode } = useContext(DarkModeContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { dispatch } = useContext(DarkModeContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [pagesTemplate, setPagesTemplate] = useState(false);
  const [showFrontEndData, setshowFrontEndData] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [templateData, setTemplateData] = useState([]);
    const fetchTemplateData = async () => {
      try {
        const response = await newRequest.get("/blogs/template");
        const data = response.data;
        setTemplateData(data);
      } catch (error) {
        console.log(error);
      }
    };

    const templatePathMap = {
      // 0: "/admin/board-template",
      1: "/admin/template7",
      2: "/admin/template6",
      3: "/admin/template3",
      4: "/admin/template4",
      5: "/admin/template5",
      6: "/admin/template2",
      7: "/admin/template1",
    };
    useEffect(() => {
     fetchTemplateData()
    }, [])

     const handleItemClickTemplate = (item, path, event) => {
      //  setSelectedItem(path);
       sessionStorage.setItem("selectedTemplate", JSON.stringify(item));

       // Check if the "Ctrl" key (or "Command" key on Mac) is pressed
       const isNewTab = event.ctrlKey || event.metaKey;
       if (isNewTab) {
         window.open(path, "_blank");
       } else {
         navigate(path);
       }
     };

       const handleContextMenu = (event, path) => {
         event.preventDefault();
         const clickX = event.clientX;
         const clickY = event.clientY;
         setContextMenuPosition({ x: clickX, y: clickY });
        //  setSelectedPath(path);
         setShowContextMenu(true);
       };
    
  return (
    <div
      className={`sidebar flex  flex-col  border-gray-200 bg-[#1E3B8B] min-h-screen text-white font-nunito ${
        i18n.language === "ar" ? "border-l" : "border-r"
      }`}
    >
      <div className=" h-12 flex items-center justify-center">
        <Link
          to="/admin/dashboard"
          style={{ textDecoration: "none" }}
          className="text-2xl font-bold"
        >
          <span className="logo">{t("AdminPanel")}</span>
          {/* <img
            onClick={() => navigate("/assets")}
            src={GtrackLogo}
            alt="logo"
            className="w-full h-44  mx-auto object-contain cursor-pointer bg-[#D3D3D3]"
            // style={{filter: invert(1) brightness(10.5)}}
          /> */}
        </Link>
      </div>
      <hr className="border-t border-gray-200" />
      <div
        className={`px-4 center ${
          i18n.language === "ar" ? "direction-rtl" : "direction-ltr"
        }`}
      >
        <ul className="space-y-3">
          <p className="title">{t("MAIN")}</p>
          <li onClick={() => navigate("/admin/dashboard")}>
            <DashboardIcon className="icon" />
            <span>{t("DASHBOARD")}</span>
          </li>
          <p className="title">{t("DATABASE CONFIGURATION")}</p>
          <Link
            to="/admin/database-config/department"
            style={{ textDecoration: "none" }}
          >
            <li>
              <StoreIcon className="icon" />
              <span>{t("DEPARTMENTS")}</span>
            </li>
          </Link>
          {/* <Link to="/user" style={{ textDecoration: "none" }}>
            <li>
              <PersonOutlinedIcon className="icon" />
              <span>All Users</span>
            </li>
          </Link> */}
          {/* <li onClick={() => navigate('/admin/database-config/users')}>
            <PersonOutlinedIcon className="icon" />
            <span>ALL USERS</span>
          </li> */}
          <li
            onClick={() => navigate("/admin/database-config/asset-categories")}
          >
            <CategoryIcon className="icon" />
            <span>{t("ASSET CATEGORIES")}</span>
          </li>
          <li className="accordionLi">
            {/* <span>ASSET OTHER DATA</span> */}
            <Accordion className="accordion px-3">
              <AccordionSummary
                className="accordionSummary "
                style={{
                  backgroundColor: darkMode ? "#111" : "black",
                  padding: "0px 5px",
                }}
                expandIcon={
                  <ExpandMoreIcon
                    style={{
                      color: "#ffff",
                    }}
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                {/* <Typography>Accordion 1</Typography> */}
                <InsertChartIcon className="icon" />{" "}
                <span>{t("ASSET OTHER DATA")}</span>
              </AccordionSummary>
              <AccordionDetails
                className="accordionDetails"
                style={{
                  backgroundColor: darkMode ? "#111" : "black",
                }}
              >
                <ul style={{ background: "black" }}>
                  <li
                    onClick={() =>
                      navigate("/admin/database-config/other-assets-condition")
                    }
                  >
                    <FiberManualRecordIcon className="icon" />{" "}
                    <span> {t("ASSETS CONDITION")}</span>
                  </li>
                  <li
                    onClick={() =>
                      navigate("/admin/database-config/other-assets-cities")
                    }
                  >
                    <FiberManualRecordIcon className="icon" />
                    <span>LIST OF CITIES</span>
                  </li>
                  <li
                    onClick={() =>
                      navigate("/admin/database-config/employee-list")
                    }
                  >
                    <FiberManualRecordIcon className="icon" />{" "}
                    <span>{t("LIST OF EMPLOYEE")}</span>
                  </li>
                  <li
                    onClick={() => navigate("/admin/database-config/all-roles")}
                  >
                    <FiberManualRecordIcon className="icon" />
                    <span>{t("ALL ROLES")}</span>
                  </li>
                  <li
                    onClick={() =>
                      navigate("/admin/database-config/brand-list")
                    }
                  >
                    <FiberManualRecordIcon className="icon" />
                    <span>{t("LIST OF BRANDS")}</span>
                  </li>
                </ul>
              </AccordionDetails>
            </Accordion>
          </li>

          <li className="accordionLi ">
            <ul
              style={{
                backgroundColor: darkMode ? "#111" : "black",
                // padding: "0px 5px",
              }}
              className="w-full"
            >
              <li onClick={() => setshowFrontEndData(!showFrontEndData)}>
                <InsertPageBreakIcon className="icon" />
                <div className="flex justify-between w-full my-auto">
                  <span className=" my-auto">{t("Front End")}</span>
                  {showFrontEndData ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </div>
              </li>
              {showFrontEndData && (
                <div className="">
                  <ul>
                    <li onClick={() => navigate("/admin/Megamenu")}>
                      <FiberManualRecordIcon className="icon" />
                      <span> Mega Menu</span>
                    </li>
                    <li onClick={() => navigate("/admin/Categories")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Categories</span>
                    </li>
                    <li onClick={() => navigate("/admin/footer_menu")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Footer Menu</span>
                    </li>
                    <li onClick={() => navigate("/admin/Header")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Header</span>
                    </li>
                    <li onClick={() => navigate("/admin/Stepter")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Step</span>
                    </li>
                    <li onClick={() => navigate("/admin/Headings")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Headings</span>
                    </li>
                    <li onClick={() => navigate("/admin/Sliders")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Sliders</span>
                    </li>
                    <li onClick={() => navigate("/admin/Resources")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Resources</span>
                    </li>
                    <li onClick={() => navigate("/admin/Card")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Card</span>
                    </li>
                    <li onClick={() => navigate("/admin/Faqs")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Faqs</span>
                    </li>
                    <li onClick={() => navigate("/admin/Language")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Language</span>
                    </li>
                    <li onClick={() => navigate("/admin/cardsection")}>
                      <FiberManualRecordIcon className="icon" />
                      <span>Paragraph section</span>
                    </li>

                    <li>
                      <ul>
                        <li onClick={() => setPagesTemplate(!pagesTemplate)}>
                          <InsertPageBreakIcon className="icon" />
                          <span>{t("Pages Template")}</span>
                          {pagesTemplate ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </li>
                        {/* <li> */}
                        {pagesTemplate && (
                          <div
                            // className="ml-3 md:ml-3 lg:ml-3 xl:ml-3 2xl:ml-3 3xl:ml-3"
                            onClick={toggleSidebar}
                          >
                            {templateData?.map((item, index) => {
                              const path =
                                templatePathMap[index] ||
                                `/admin/template${index + 1}`;
                              // const imageUrl = imageUrls[index % imageUrls.length];
                              return (
                                <div key={index}>
                                  <ul
                                    // className={`main-images-container  ${
                                    //   i18n.language === "ar"
                                    //     ? "flex-row-reverse justify-start"
                                    //     : "flex-row justify-start"
                                    // }`}
                                    onClick={(event) =>
                                      handleItemClickTemplate(item, path, event)
                                    }
                                    onContextMenu={(event) =>
                                      handleContextMenu(event, path)
                                    }
                                  >
                                    {/* <img
                          src={imageUrl}
                          className="main-inside-image bg-white rounded-full"
                          alt=""
                        /> */}
                                    {/* <p></p> */}

                                    <li>
                                      <FiberManualRecordIcon className="icon" />
                                      <span>{item?.name}</span>
                                    </li>
                                  </ul>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        {/* </li> */}
                      </ul>
                    </li>
                  </ul>
                </div>
              )}
            </ul>
          </li>

          <li onClick={() => navigate("/admin/loation-tags")}>
            <AddLocationIcon className="icon" />
            <span>{t("LOCATION TAGS")}</span>
          </li>
          {/* <li onClick={() => navigate('/admin/database-config/brand-list')}>
            <BrandingWatermarkIcon className="icon" />
            <span>LIST OF BRANDS</span>
          </li> */}

          <p className="title">{t("ACCOUNTS")}</p>
          <li onClick={() => navigate("/admin/users-account")}>
            <CreditCardIcon className="icon" />
            <span> {t("USERS ACCOUNT")}</span>
          </li>

          <p className="title">{t("LIST OF ALL ASSETS")}</p>

          <li onClick={() => navigate("/admin/all-assets")}>
            <WebAssetIcon className="icon" />
            <span> {t("ALL ASSET")}</span>
          </li>
          <li onClick={() => navigate("/admin/company-info")}>
            <SettingsIcon className="icon" />
            <span>{t("SETTINGS")}</span>
          </li>

          {/* <li>
            <AccountCircleOutlinedIcon className="icon" />
            <span>Profile</span>
          </li> */}
          {/* <li>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li> */}
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
